// Coverage & Roadmap Slice 3 — compact Home strip. A single honest
// line: what's live now + how much is verifiably coming, linking to
// the full roadmap. Self-hides while loading or if the gate truth
// has nothing live (honest-empty — never a fabricated teaser).

import { Link } from "react-router-dom";
import { useCoverageOverview } from "../../sportCoverage/useCoverageOverview.ts";

export function HomeCoverageStrip(): JSX.Element | null {
  const { buckets, loading } = useCoverageOverview();
  if (loading) return null;
  // Honest-empty: nothing live ⇒ nothing to advertise.
  if (buckets.liveCount === 0) return null;

  return (
    <Link
      to="/coverage"
      data-testid="home-coverage-strip"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "10px 14px",
        border: "1px solid var(--sa-hairline, #2a2a30)",
        borderRadius: 6,
        textDecoration: "none",
        color: "var(--sa-fg-secondary, #c8c8ce)",
        fontFamily: "var(--sa-font-mono, monospace)",
        fontSize: 12,
      }}
    >
      <span style={{ color: "var(--sa-accent-positive, #1fbf75)" }}>
        {buckets.liveCount} live
      </span>
      <span style={{ color: "var(--sa-fg-muted, #6a6a72)" }}>·</span>
      <span>{buckets.comingCount} verified and coming</span>
      <span style={{ marginLeft: "auto", color: "var(--sa-accent-saffron, #e0a106)" }}>
        Coverage &amp; roadmap →
      </span>
    </Link>
  );
}
